export function appendShopSearchParam(params, key, value) {
  if (Array.isArray(value)) {
    value
      .map((entry) => String(entry || '').trim())
      .filter(Boolean)
      .forEach((entry) => params.append(key, entry));
    return;
  }

  if (typeof value === 'string' && value.trim()) {
    params.set(key, value.trim());
  }
}

function appendExistingSearchParams(params, searchParams) {
  if (!searchParams) {
    return;
  }

  if (typeof searchParams.entries === 'function') {
    for (const [key, value] of searchParams.entries()) {
      if (typeof value === 'string' && value.trim()) {
        params.append(key, value.trim());
      }
    }

    return;
  }

  Object.entries(searchParams).forEach(([key, value]) => {
    appendShopSearchParam(params, key, value);
  });
}

export function normalizeShopParamArray(value) {
  if (Array.isArray(value)) {
    return Array.from(
      new Set(value.map((entry) => String(entry || '').trim()).filter(Boolean)),
    );
  }

  if (typeof value === 'string' && value.trim()) {
    return [value.trim()];
  }

  return [];
}

export function buildShopPath(searchParams, updates = {}, pathname = '/shop') {
  const params = new URLSearchParams();

  appendExistingSearchParams(params, searchParams);

  Object.entries(updates).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      params.delete(key);

      value
        .map((entry) => String(entry || '').trim())
        .filter(Boolean)
        .forEach((entry) => params.append(key, entry));
      return;
    }

    if (value === null || value === undefined || value === '') {
      params.delete(key);
      return;
    }

    params.set(key, String(value));
  });

  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
}
